"use client";

import Script from "next/script";
import { useCookiePreferences } from "@/hooks/useCookiePreferences";

const FACEBOOK_PIXEL_ID = "402656810397884";
const IS_PRODUCTION = process.env.NODE_ENV === "production";

export default function FacebookPixelLoader() {
  const preferences = useCookiePreferences();
  const marketingAllowed = Boolean(preferences?.marketing);

  if (!IS_PRODUCTION || !marketingAllowed) {
    return null;
  }

  return (
    <Script id="facebook-pixel" strategy="lazyOnload">
      {`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${FACEBOOK_PIXEL_ID}');
fbq('track', 'PageView');`}
    </Script>
  );
}
